export default __webpack_public_path__ + "static/media/bisi_powder.5f16e250.png";